export default "__VITE_ASSET__GuJF0fNk__"